import type { CardDefinition, PendingChoice } from "../../domain/types/index.js";

type HandSelection = Extract<PendingChoice, { kind: "cellar" | "inn" | "handDisruption" | "meeting" | "sendoff" | "workerCycle" | "stables" | "training" | "caseExclude" | "psychologicalCounseling" | "specialTaskTeam" }>;

export function isHandSelection(pending: PendingChoice | null): pending is HandSelection {
  return pending?.kind === "caseExclude" || pending?.kind === "cellar" || pending?.kind === "inn"
    || pending?.kind === "handDisruption" || pending?.kind === "meeting" || pending?.kind === "sendoff" || pending?.kind === "workerCycle" || pending?.kind === "stables" || pending?.kind === "training"
    || pending?.kind === "psychologicalCounseling" || pending?.kind === "specialTaskTeam";
}

export function isEligibleHandSelection(pending: HandSelection, definition: CardDefinition, temporaryForCase = false): boolean {
  if (pending.kind === "meeting") return definition.type === "action";
  if (pending.kind === "sendoff" || pending.kind === "stables") return definition.type === "worker";
  if (pending.kind === "training") return definition.id === "intern" || definition.id === "mid";
  if (pending.kind === "psychologicalCounseling") return definition.id === "idle" && !temporaryForCase;
  if (pending.kind === "specialTaskTeam") return definition.id === "idle";
  return true;
}

export function selectedHandIds(pending: HandSelection): string[] {
  return pending.kind === "meeting"
    ? pending.targetInstanceId ? [pending.targetInstanceId] : []
    : pending.selected;
}
